import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routers from "../../routers";
import TopHeader from "./TopHeader";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import AppContext from "./context";
import { useTopHeaderNotifications } from "./TopHeader/hooks";
import Notifications from "./TopHeader/TopHeaderNotifications";
import styled, { createGlobalStyle } from "styled-components";
import * as colors from "../../assets/_base/colors";

import { getConfig } from "../../utils/config";

const config = getConfig();

const font = config.theme.font;

const GlobalStyle = createGlobalStyle`
  /* Importa as famílias do Google Fonts */
  @import url('${font.url}');
* {
  font-family: '${font.family}';
}
h1,
h2,
h3,
h4 {
  font-size: 1.3em;
}
`;

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${colors.lightCyan};
`;

const PageWrapper = styled.main`
  flex: 1;
  margin-left: 240px;
  padding: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #f8f9fa;
  border-radius: 23px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
  margin-right: 1rem;
  margin-bottom: 5.4rem;
  overflow-x: hidden;
  transition: all 0.3s ease-in-out;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    padding: 1rem;
    border-radius: 0;
  }
`;

const StyledFooter = styled.footer`
  position: fixed;
  bottom: 0;
  left: 240px;
  right: 0;
  height: 50px;
  background: #ffffff;
  color: #495057;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #dee2e6;
  z-index: 900;

  @media (max-width: 768px) {
    left: 0;
  }
`;

export default function App() {
  const ref = React.useRef(null);
  const getNotifications = useTopHeaderNotifications();
  const [currentBranch, setCurrentBranch] = React.useState({});
  const [notifications, setNotifications] = React.useState([]);

  React.useEffect(() => {
    let branch = window.localStorage.getItem("easygestorweb_current_branch");
    if (branch) {
      branch = JSON.parse(branch);
      setCurrentBranch(branch);
      setNotifications(getNotifications(branch));
    }
  }, [ref.current]);

  return (
    <BrowserRouter>
      <GlobalStyle />
      <AppContext.Provider value={{ currentBranch }}>
        <Wrapper ref={ref}>
          <Sidebar />
          <PageWrapper>
            <TopHeader />
            <Notifications notifications={notifications} />
            <Routers />
          </PageWrapper>
          <StyledFooter>
            <Footer />
          </StyledFooter>
        </Wrapper>
      </AppContext.Provider>
    </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/index.jsx